import { Accessibility } from "~/src/accessibility/Accessibility";
import { Element } from "~/src/accessibility/Element";

export class Menubar extends Element {
  constructor(menubarClass, mobileHamburger) {
    super(menubarClass);
    this.hamburger = mobileHamburger ? JSON.parse(JSON.stringify(mobileHamburger)) : null;
    this.initKeyboardNavigation();
    this.initMobile();
    this.initHamburger();
  }

  initMobile() {
    if (!this.hamburger) return;

    const hasIconProvided = this.hamburger.hasOwnProperty("icon");
    const hasDialogProvided = this.hamburger.hasOwnProperty("dialog");
    if (hasIconProvided && hasDialogProvided) return;
    if (hasIconProvided || hasDialogProvided)
      throw new Error(`Cannot initialize mobile hamburget without Icon or Dialog properties.
                       Please provide open handler class name and dialog it should open class name.`);
  }

  initKeyboardNavigation() {
    const $menusSelector = this.hamburger ? this.$container.add(this.hamburger.dialog) : this.$container;
    $menusSelector.on("keydown", (e) => {
      this.handleNavigation(e);
    });
  }

  initHamburger() {
    if (!this.hamburger) return;
    this.$container.find(this.hamburger.icon).on("click keydown", (e) => {
      this.openHamburgerDialog(e);
    });
  }

  openHamburgerDialog(event) {
    const { RETURN, SPACE, DOWN } = Accessibility.keyCodes;
    if (event.type === "keydown" && [RETURN, SPACE, DOWN].includes(event.keyCode)) {
      this.toggleMobileNav();
      $(this.hamburger.dialog).find("li").first().children("a").focus();
    } else if (event.type === "click") {
      this.toggleMobileNav();
    }
  }

  toggleMobileNav() {
    $(this.hamburger.dialog).toggleClass(this.hamburger.dialog.slice(1) + "--active");
    $(this.hamburger.icon).toggleClass(this.hamburger.icon.slice(1) + "--active");
    $(this.hamburger.dialog).slideToggle();
  }

  handleNavigation(event) {
    const { LEFT, RIGHT, HOME, END, ESC } = Accessibility.keyCodes;

    switch (event.keyCode) {
      case RIGHT:
        $(event.target).closest("li").next("li:visible").children("a").focus();
        break;

      case LEFT:
        $(event.target).closest("li").prev("li:visible").children("a").focus();
        break;

      case HOME:
        $(event.target).closest("ul").children("li:visible").first().children("a").focus();
        break;

      case END:
        $(event.target).closest("ul").children("li:visible").last().children("a").focus();
        break;
      case ESC:
        if (this.hamburger) this.toggleMobileNav();
        break;
      default:
        return;
    }
  }
}
